import { useStaticQuery, graphql } from 'gatsby'

/**
 * Maps founder data to image objects.
 *
 * @param {Array} data - The array of founder data to be processed.
 * @returns {Array} An array of image objects with id, title, src, altText, link, and description.
 */
const mapFoundersToImageObjects = data => {
  return data?.map(founder => ({
    id: founder.id,
    title: founder.title,
    src: founder.featuredImage?.node?.sourceUrl,
    altText: founder.featuredImage?.node?.altText,
    link: founder.foundersClub?.link,
    description: founder.foundersClub?.description,
    objectFit: founder.foundersClub?.imageobjectfit,
    areas: founder.foundersClub?.foundersClubArea,
  }))
}

/**
 * Custom hook to query and retrieve data for all founders who are part of the founders club.
 * This hook uses Gatsby's useStaticQuery to fetch data from GraphQL.
 *
 * @param {string} area - (optional) Area to filter founders by.
 * @returns {Array} An array of founder data with title, image information, description, and link details.
 */

export const useAllFoundersQuery = (area = null) => {
  const data = useStaticQuery(graphql`
    {
      allWpFounder(filter: { foundersClub: { showFounder: { eq: true } } }) {
        nodes {
          id
          title
          featuredImage {
            node {
              sourceUrl
              altText
            }
          }

          foundersClub {
            description
            imageobjectfit
            link {
              target
              url
            }
            foundersClubArea
          }
        }
      }
    }
  `)

  const allFounders = mapFoundersToImageObjects(data?.allWpFounder?.nodes)

  return area
    ? allFounders.filter(
        founder => Array.isArray(founder.areas) && founder.areas.includes(area),
      )
    : allFounders
}
